enum TO_MESSAGES {
	TOGGLE_DARK_MODE = "toggleDarkMode",
}

enum FROM_MESSAGES {
	DARK_MODE_UPDATED = "darkModeUpdated",
}

type PlayerMessageCallbacks = {
	[key in FROM_MESSAGES]?: (event: MessageEvent) => void;
};

type ListenerCallbacks = PlayerMessageCallbacks & {
	load: () => void;
	unload: () => void;
};

type PlayerCache = {
	iframe: HTMLIFrameElement | null;
	callbacks: ListenerCallbacks;
	loadListener: () => void;
	unloadListener: () => void;
	playerMessageListener: (event: MessageEvent) => void;
};

export type { ListenerCallbacks, PlayerCache };
export { FROM_MESSAGES, TO_MESSAGES };
